import { request } from '../../../modules/events/actions/get';
import { update } from '../../../modules/events/actions/update';
import socketPromise from '../../../websocket';

export function subscribe(dispatch, action) {
    socketPromise.then(socket => {
        socket.subscribe('*:Event:' + action.id, ({ body }) => {
            if (body.participant) {
                dispatch(request(action.id));
            } else {
                dispatch(update(action.id, body));
            }
        });
    });
}
